// extracted by mini-css-extract-plugin
module.exports = {"label":"StatusLabel_label__1rWin","blue":"StatusLabel_blue__3BEHr","red":"StatusLabel_red__VN2h7","yellow":"StatusLabel_yellow__2QGnV","green":"StatusLabel_green__1cpKn"};